let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kz9AV")).then(() => parcelRequire('lR9rA'));